import { formatMoney } from "utils";
import React, { useState } from "react";
import ReportsView from "../ReportsView";

const Footer = ({ id, account }) => {
    const [reportLoading, setReportLoading] = useState({ pdf: false, excel: false });

    return (
        <div className="fixed-bottom w-100 bg-app py-2 px-3 text-white d-flex">
            <h3 className="my-auto text-left text-md-left col-8" title="Account Balance">
                Balance :
                {
                    account ?
                        <span className="fs-5">
                            <i>{formatMoney(account.get("balance"))}</i>
                        </span> : ""
                }
            </h3>
            {account && (
                <div className="d-flex justify-content-end w-100">
                    <div>
                        <div className="btn btn-sm bg-app dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <span className="d-flex align-items-center">
                                {reportLoading.pdf ?
                                    <span className="spinner-border text-white mt-2" role="status" aria-hidden="true" />
                                    : <i className="bi bi-file-pdf fs-2 text-white" />
                                }
                            </span>
                        </div>
                        <ReportsView id={id} setReportLoading={setReportLoading} type="pdf" />
                    </div>
                    <div>
                        <div className="btn btn-sm bg-app dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <span className="d-flex align-items-center">
                                {reportLoading.excel ?
                                    <span className="spinner-border text-white mt-2" role="status" aria-hidden="true" />
                                    : <i className="bi bi-filetype-xls fs-2 text-white" />
                                }
                            </span>
                        </div>
                        <ReportsView id={id} setReportLoading={setReportLoading} type="excel" />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Footer;